import React from 'react';
import ShipmentStatusCard from '../../components/shipment-status-card';
import { ShipmentStatusGroupPropType } from '../../prop-types/shipment-status';

import style from './shipment-status.module.less';
import CardPropGenerators from './card-prop-generators';

const renderShipmentStatusCard = (generatorId, props) => {
  const propGenerator = CardPropGenerators.find((generator) => generator.id === generatorId);
  if (!propGenerator) {
    return null;
  }
  return <ShipmentStatusCard {...propGenerator.generateProps(props)} />;
};

const getStatusCardIds = (returnEmailInformation, isThirdPartyFulfillment) => {
  if (returnEmailInformation) {
    return ['label', 'return-email'];
  }
  if (isThirdPartyFulfillment) {
    return ['packing-slip', 'notifications'];
  }
  return ['packing-slip', 'label', 'notifications'];
};

const ShipmentStatus = (props) => {
  const { returnEmailInformation, isThirdPartyFulfillment } = props;
  const statusCardIds = getStatusCardIds(returnEmailInformation, isThirdPartyFulfillment);
  return <div className={style['shipment-status']}>{statusCardIds.map((cardId) => renderShipmentStatusCard(cardId, props))}</div>;
};

ShipmentStatus.propTypes = ShipmentStatusGroupPropType;

export default ShipmentStatus;
